<h2>{{reward ? ('Editing CLO "' + reward.title + '"') : 'Add CLO'}}</h2>
@if (reward) {
  <h4>{{reward.id}}</h4>
}

<form [formGroup]="form" class="form">
  <mat-form-field appearance="outline">
    <mat-label>Title</mat-label>
    <input matInput formControlName="title">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Linked Reward</mat-label>
    <mat-select formControlName="linkedreward">
      @for (r of rewards; track r) {
        <mat-option [value]="r.id">{{r.name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Transaction Match Regexp</mat-label>
    <input matInput formControlName="transactionRegExp">
  </mat-form-field>

  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Redeem Details</mat-label>
    <app-json formControlName="redeemDetails" baseTable="rewardsPurchased" fieldHint="redeemDetails"></app-json>
  </mat-form-field>

  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Visible Expression</mat-label>
    <app-json formControlName="visibleExpression" baseTable="rewardsPurchased" fieldHint="visibleExpression"></app-json>
  </mat-form-field>

  <mat-form-field appearance="outline" class="json-field">
    <mat-label>Schedule</mat-label>
    <app-json formControlName="schedule" baseTable="rewardsPurchased" fieldHint="schedule"></app-json>
  </mat-form-field>

  <div class="actions">
    <button mat-stroked-button color="primary" (click)="cancel()">Cancel</button>
    @if (reward) {
      <button mat-stroked-button color="warn" (click)="delete()">Delete</button>
    }
    <button mat-raised-button color="primary" [disabled]="form.invalid || saving" (click)="save()">Save</button>
  </div>
</form>
